import { OrganizationApi, ToastStateHandler } from '../../../api';
import { ICallback } from '../../../commonTypes/hook.types';
import { CreateOrganizationDto, OrganizationPublicDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { useState } from 'react';
import { useTranslation } from '../../useTranslation';

const useHttpPostCreateOrganization = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [organization, setOrganization] = useState<OrganizationPublicDto>();
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const execCreate = (body: CreateOrganizationDto, callback: ICallback) => {
        const { exec, clearCache, abort } = organizationApi.createOrganization({
            body,
            onSuccess: res => {
                setOrganization(res.body);
                clearCache();
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: error => {
                if (error.includes("with given 'name' already exists")) {
                    toastHandler.push(
                        'error',
                        t('organization.createOrganizationTitle'),
                        t('organization.createOrganizationMessage_Failed_Name_Already_Exists').replace('ORGANIZATION_NAME', body.name)
                    );
                } else if (error.includes("with given 'ownerId' already exists.")) {
                    toastHandler.push(
                        'error',
                        t('organization.createOrganizationTitle'),
                        t('organization.createOrganizationMessage_Failed_UserOrg_Already_Exists')
                    );
                } else {
                    toastHandler.push(
                        'error',
                        t('organization.createOrganizationTitle'),
                        t('organization.createOrganizationMessage_Failed').replace('ORGANIZATION_NAME', body.name)
                    );
                }
            },
        });
        exec();
        return abort;
    };

    return {
        execCreate,
        organization,
    };
};

export default useHttpPostCreateOrganization;
